import React, { useEffect, useContext } from "react";
import axios from "axios";
import { GlobalContext } from "../constants/Context";
import { logPlayCricketResponse } from "../utils/playCricketLogger";
const MatchesAPI = ({ siteId, season, onDataLoaded, onError, onLoading }) => {
  const { API_TOKEN } = useContext(GlobalContext);

  useEffect(() => {
    if (!siteId || !season) return;

    const fetchMatches = async () => {
      const url = `https://www.play-cricket.com/api/v2/matches.json?&site_id=${siteId}&season=${season}&api_token=${API_TOKEN}`;
      try {
        onLoading(true);
        const response = await axios.get(url);
        logPlayCricketResponse({
          endpoint: "matches",
          requestUrl: url,
          httpStatus: response.status,
          isSuccess: true,
          rawResponse: response.data,
        });
        const matchesData = response.data.matches || [];
        onDataLoaded(matchesData);
        onLoading(false);
      } catch (err) {
        logPlayCricketResponse({
          endpoint: "matches",
          requestUrl: url,
          httpStatus: err.response?.status || null,
          isSuccess: false,
          rawResponse: err.response?.data || null,
          errorMessage: err.message,
        });
        onError(err.message);
        onLoading(false);
      }
    };

    fetchMatches();
  }, [siteId, season]);

  return null;
};

export default MatchesAPI;